export { BtnIconAdd6 } from "./BtnIconAdd6";
